import { REST_METHOD, REST_URL } from '../constants';
import request, { requestKnowledge, RequestParams } from './api';

export async function searchAllKnowledge(param: any) {
  try {
    const {
      keyword,
      page_size,
      page_index,
      user_name,
      knowledge_bases,
      categories,
      order_by,
      language,
      showAll
    } = param;
    let requestParams;
    if (param.keyword) {
      requestParams = {
        url: `${REST_URL.SEARCH}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {
          keyword: keyword,
          page_size: page_size,
          page_index: page_index,
          user_name: user_name,
          order_by: order_by,
          knowledge_bases: knowledge_bases,
          categories: categories,
          language: language,
        },
      };
    } else {
      if(showAll){
        requestParams = {
          url: `${REST_URL.SEARCH}`,
          method: `${REST_METHOD.GET}`,
          queryParams: {
            keyword: '',
            page_size: page_size,
            page_index: page_index,
            user_name: user_name,
            order_by: order_by,
            knowledge_bases: knowledge_bases,
            categories: categories,
            language: language,
          },
        };
      }else{
        requestParams = {
          url: `${REST_URL.GET_ALL_FEATURE}`,
          method: `${REST_METHOD.GET}`,
          queryParams: {
            page_size: page_size,
            page_index: page_index,
            user_name: user_name,
            language: language,
          },
        };
      }
      
    }

    return requestKnowledge(requestParams);
  } catch (error) {
    throw error;
  }
}

export async function getArticleByURLType(url: string, param: any) {
  try {
    const requestParams = {
      url: `${url}`,
      method: `${REST_METHOD.GET}`,
      queryParams: param,
    };
    const response = await requestKnowledge(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getFilterKnowledgeBaseAndCategory(param: any) {
  try {
    const { keyword, user_name, knowledge_bases, categories, language } = param;
    let requestParams;
    if (param.keyword) {
      requestParams = {
        url: `${REST_URL.FILTER_CATEGORY}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {
          keyword: keyword,
          user_name: user_name,
          knowledge_bases: knowledge_bases,
          categories: categories,
          language: language,
        },
      };
    }else{
      requestParams = {
        url: `${REST_URL.FILTER_CATEGORY}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {
          keyword: '',
          user_name: user_name,
          knowledge_bases: knowledge_bases,
          categories: categories,
          language: language,
        },
      };
    }
  
    return requestKnowledge(requestParams);
  } catch (error) {
    throw error;
  }
}

export async function getDetailByKBNumber(number: Number, userName: String, lang?: String) {
  try {
    const requestParams = {
      url: `${REST_URL.RETRIEVE}`,
      method: `${REST_METHOD.GET}`,
      queryParams: { number: number, user_name: userName, language: lang },
    };
    const response = await requestKnowledge(requestParams);

    return response;
  } catch (error) {
    throw error;
  }
}

export async function provideFeedBack(paramObj: any) {
  const hasFeedback = !!paramObj?.kb_feedback_reason;
  try {
    const requestParams = {
      url: hasFeedback ? REST_URL.FEEDBACK_TASK : REST_URL.FEEDBACK,
      method: `${REST_METHOD.POST}`,
      data: paramObj,
    };
    const response = await requestKnowledge(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function uploadFeedbackAttachment(
  payload: File,
  params: { kb_feedback_id: string; file_name: string; type?: string },
) {
  try {
    const requestParams = {
      url: `${REST_URL.FEEDBACK_UPLOAD_ATTACHMENT}`,
      method: REST_METHOD.POST,
      queryParams: params,
      data: payload,
      options: {
        'Content-Type': 'application/octet-stream',
        noCache: true,
      },
    };
    const response = await requestKnowledge(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserRatings(paramObj: any) {
  try {
    const requestParams = {
      url: `${REST_URL.KB_RATINGS}`,
      method: `${REST_METHOD.GET}`,
      queryParams: paramObj,
      options: {
        noCache: true,
      },
    };
    const response = await requestKnowledge(requestParams);
    const result = response?.data || {};
    return result;
  } catch (error) {
    throw error;
  }
}
export async function getUserUsefuls(paramObj: any) {
  try {
    const requestParams = {
      url: `${REST_URL.KB_USEFULS}`,
      method: `${REST_METHOD.GET}`,
      queryParams: paramObj,
      options: {
        noCache: true,
      },
    };
    const response = await requestKnowledge(requestParams);
    const result = response?.data || {};
    return result;
  } catch (error) {
    throw error;
  }
}
export async function getUserComments(paramObj: any) {
  try {
    const requestParams = {
      url: `${REST_URL.KB_COMMENTS}`,
      method: `${REST_METHOD.GET}`,
      queryParams: paramObj,
      options: {
        noCache: true,
      },
    };
    const response = await requestKnowledge(requestParams);
    const result = response?.data || [];
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getLatestComment(paramObj: any) {
  try {
    const requestParams = {
      url: `${REST_URL.LAST_COMMENT}`,
      method: `${REST_METHOD.GET}`,
      queryParams: paramObj,
      options: {
        noCache: true,
      },
    };
    const response = await requestKnowledge(requestParams);
    const result = response?.data || {};
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getUsefulPercentage(paramObj: any) {
  try {
    const requestParams = {
      url: `${REST_URL.RETRIEVE_USEFUL}`,
      method: `${REST_METHOD.GET}`,
      queryParams: paramObj,
      options: {
        noCache: true,
      },
    };
    const response = await requestKnowledge(requestParams);
    return response?.data || {};
  } catch (error) {
    throw error;
  }
}

export async function updateViewCount(userName: String, kb_id: String) {
  try {
    const requestParams = {
      url: `/${REST_URL.VIEW_COUNT}`,
      method: `${REST_METHOD.POST}`,
      data: { kb_uid: kb_id, user_name: userName },
    };
    const response = await requestKnowledge(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function mostViewedArticles(paramObj: any) {
  try {
    const requestParams = {
      url: `${REST_URL.RETRIEVE_TOP_VIEW_BY_CATE}`,
      method: `${REST_METHOD.GET}`,
      queryParams: paramObj,
    };
    const response = await requestKnowledge(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export const getTopThreeKnowledgeNews = async (params: any) => {
  try {
    const requestParams = {
      url: `${REST_URL.NEWS}`,
      method: `${REST_METHOD.GET}`,
      queryParams: params,
    };
    let response = await requestKnowledge(requestParams);

    response =
      response && response.data
        ? response.data.data
          ? response.data.data
          : response.data
        : response;

    return response;
  } catch (error) {
    throw error;
  }
};

export async function updateLikeComment(userName: string, commentId: string) {
  try {
    const requestParams = {
      url: `${REST_URL.LIKE_COMMENT}`,
      method: `${REST_METHOD.POST}`,
      data: {
        user_name: userName,
        comment_uid: commentId,
      },
    };
    const response = await requestKnowledge(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateUnlikeComment(commentId: string) {
  try {
    const requestParams = {
      url: `${REST_URL.UNLIKE_COMMENT}`,
      method: `${REST_METHOD.POST}`,
      queryParams: {
        uid: commentId,
      },
    };
    const response = await requestKnowledge(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteComment(commentId: string) {
  try {
    const requestParams = {
      url: `${REST_URL.DELETE_COMMENT}`,
      method: `${REST_METHOD.DELETE}`,
      queryParams: {
        uid: commentId,
      },
    };
    const response = await requestKnowledge(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function editComment(uid: String, comments: any) {
  try {
    const requestParams = {
      url: `${REST_URL.KB_COMMENT}/${uid}`,
      method: `${REST_METHOD.PUT}`,
      data: { comments },
    };
    const response = await requestKnowledge(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function downloadAttachment(sysId: string) {
  try {
    const requestParams: RequestParams = {
      url: `${REST_URL.ATTACHMENT}/${sysId}${REST_URL.FILE}`,
      method: `${REST_METHOD.GET}`,
      responseType: 'blob',
    };
    const response = await requestKnowledge(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getAllAttachment(sysId: string){
  try {
    const requestParams = {
      url: `${REST_URL.ALL_ATTACHMENT}`,
      method: `${REST_METHOD.GET}`,
      queryParams: {
        kb_sys_id: sysId,
      }
    };
    const response = await requestKnowledge(requestParams);
    return response.data;
  } catch (error) {
    throw error;
  }

}

export async function searchGlobal({
  userName,
  userId,
  userSysId,
  keyword,
  limit,
  language,
  lang2iso,
}: {
  userName: string;
  userId: string;
  userSysId: string;
  keyword: string;
  limit: number;
  language: string;
  lang2iso: string;
}) {
  const requestParams = {
    url: `${REST_URL.GLOBAL_SEARCH}`,
    method: `${REST_METHOD.GET}`,
    queryParams: {
      user_name: userName,
      user_sys_id: userSysId,
      keyword,
      limit,
      language,
      user_id: userId,
      lang2iso
    },
  };
  const response = await request(requestParams);
  return response.data;
}
